import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeDefaultShipmentPickupLocation } from './normalize';

export const fetchDefaultShipmentPickupLocation = createProvider(api.fetchDefaultShipmentPickupLocation)
  .andThen((res) => normalizeDefaultShipmentPickupLocation(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
